import React from 'react';

export interface IGridStyle {
    dl: React.CSSProperties;
    dt: React.CSSProperties;
    theadCol: React.CSSProperties;
    theadColName: React.CSSProperties;
    theadColOrigin: React.CSSProperties;
    theadColTarget: React.CSSProperties;
    theadColAction: React.CSSProperties;
    tbodyColName: React.CSSProperties;
    tbodyColOrigin: React.CSSProperties;
    tbodyColTarget: React.CSSProperties;
    tbodyColAction: React.CSSProperties;
    headerStyles: any;
}


export const CONTENT_MARGIN_TOP_STYLE: React.CSSProperties = { marginTop: '15px' };

export const FONT_FAMILY_STYLES = { fontFamily: 'Win10Emoji, Segoe UI Emoji, Noto Color Emoji, Apple Color Emoji, Android Emoji, EmojiSymbols' };

export const BENEFIT_COMPARISON_PANEL_ID = 'benefit-comparison-panel';
export const GROUP_NUMBER_COMPARISON_PANEL_ID = 'group-number-comparison-panel';

export const QUICK_NAV_OVERLAY_VISIBLE_STYLE: React.CSSProperties = {
    height: '100vh',
    width: '100%',
    position: 'fixed',
    backgroundColor: 'rgba(0,0,0,0.92)',
    left: '0',
    top: '0',
    overflowY: 'auto',
    transition: '0.6s',
    zIndex: 100000,
    display: 'block',
};

export const QUICK_NAV_OVERLAY_HIDDEN_STYLE: React.CSSProperties = {
    ...QUICK_NAV_OVERLAY_VISIBLE_STYLE,
    display: 'none',
};

// Floating panel styles (from left)
export const QUICK_NAV_FLOATING_BACKDROP_VISIBLE: React.CSSProperties = {
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    backgroundColor: 'rgba(0,0,0,0.7)',
    zIndex: 99999,
    transition: 'opacity 0.3s ease-out',
    opacity: 1,
    display: 'block',
};

export const QUICK_NAV_FLOATING_BACKDROP_HIDDEN: React.CSSProperties = {
    ...QUICK_NAV_FLOATING_BACKDROP_VISIBLE,
    opacity: 0,
    pointerEvents: 'none',
};

export const QUICK_NAV_FLOATING_PANEL_VISIBLE: React.CSSProperties = {
    position: 'fixed',
    left: '0',
    top: '0',
    height: '100vh',
    width: 'max(420px, 40vw)',
    backgroundColor: '#1f1f1f',
    overflowY: 'auto',
    transition: 'transform 0.3s ease-out',
    transform: 'translateX(0)',
    zIndex: 100000,
    boxShadow: '2px 0 12px rgba(0,0,0,0.4)',
    overflowX: 'hidden',
};

export const QUICK_NAV_FLOATING_PANEL_HIDDEN: React.CSSProperties = {
    ...QUICK_NAV_FLOATING_PANEL_VISIBLE,
    transform: 'translateX(-100%)',
};

export const QUICK_NAV_OVERLAY_CONTENT_STYLE: React.CSSProperties = {
    marginTop: '25px',
    marginLeft: '50px',
    marginBottom: '50px',
    width: '95%',
    transition: '0.6s',
};

export const QUICK_NAV_STACK_TOKENS = { childrenGap: '5px' };
export const QUICK_NAV_CHILD_STACK_TOKENS = { childrenGap: 2 };
export const QUICK_NAV_SECTION_STACK_TOKENS = { childrenGap: 0 };


export const QUICK_NAV_CHILD_STACK_STYLES = { root: { marginLeft: '20px', marginTop: '5px' } };
export const QUICK_NAV_SECTION_STACK_STYLES = { root: { marginLeft: '40px' } };
export const QUICK_NAV_INDENT_STYLE: React.CSSProperties = { marginLeft: '20px' };
export const QUICK_NAV_GROUP_STYLE: React.CSSProperties = { marginLeft: '15px' };
export const QUICK_NAV_STICKY_SEGMENT_TITLE_STYLE: React.CSSProperties = {
    position: 'sticky',
    top: '65px',
    zIndex: 3,
    backgroundColor: '#1f1f1f',
    paddingTop: '6px',
    paddingBottom: '6px',
};
export const QUICK_NAV_STICKY_NESTED_SEGMENT_TITLE_STYLE: React.CSSProperties = {
    ...QUICK_NAV_STICKY_SEGMENT_TITLE_STYLE,
    zIndex: 2,
    marginLeft: '20px',
};
export const QUICK_NAV_STICKY_TAB_TITLE_STYLE: React.CSSProperties = {
    position: 'sticky',
    top: '90px',
    zIndex: 2,
    backgroundColor: '#1f1f1f',
    paddingTop: '4px',
    paddingBottom: '4px',
};
export const QUICK_NAV_STICKY_SECTION_TITLE_STYLE: React.CSSProperties = {
    position: 'sticky',
    top: '120px',
    zIndex: 1,
    backgroundColor: '#1f1f1f',
    paddingTop: '2px',
    paddingBottom: '2px',
};

export const TABLE_STYLE: React.CSSProperties = { width: '100%', borderCollapse: 'collapse', marginBottom: '15px' };
export const TABLE_HEAD_STYLE: React.CSSProperties = { borderBottom: '1px solid gray' };

export const TABLE_STYLES: IGridStyle = {
    dl: {
        width: '100%',
        padding: '5px',
        textAlign: 'center',
    },
    dt: {
        fontWeight: 680,
        textAlign: 'right',
        width: '400px',
        padding: '5px',
    },

    theadCol: {
        textAlign: 'left',
        padding: '5px',
    },
    theadColName: {
        textAlign: 'left',
        padding: '5px',
    },
    theadColOrigin: {
        textAlign: 'left',
        padding: '5px',
    },
    theadColTarget: {
        textAlign: 'left',
        padding: '5px',
    },
    theadColAction: {
        textAlign: 'center',
        padding: '5px',
        width: '140px',
    },

    tbodyColName: {
        textAlign: 'left',
        padding: '5px',
    },
    tbodyColOrigin: {
        borderLeft: '1px solid lightgray',
        textAlign: 'left',
        verticalAlign: 'top',
        padding: '5px',
        width: '30%',
        whiteSpace: 'pre-line',
    },
    tbodyColTarget: {
        borderLeft: '1px solid lightgray',
        textAlign: 'left',
        verticalAlign: 'top',
        padding: '5px',
        width: '30%',
        whiteSpace: 'pre-line',

        // backgroundColor: 'rgb(0, 0, 0)',
        // filter: 'blur(4px)',
        // transition: '0.3s',
    },
    tbodyColAction: {
        borderLeft: '1px solid lightgray',
        textAlign: 'center',
        width: '140px',
    },

    headerStyles: {
        root: { fontWeight: '600' },
    },
};